// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"Card-primaryButton-1k81fa","card":"Card-card-2-t7-T","header":"Card-header-1YKg6o","divider":"Card-divider-JhcFkY","content":"Card-content-13EkGX"};